import React from 'react'
import GradiLink from './gradi-link'
import SocialIcon from './social-icon'


const Socials = ({ currentBrand, large }) => { 
  if (currentBrand === null || currentBrand.socials == null) {
    return null
  }
  const urls = currentBrand.socials.map((object,i) => { return object.link })
  return (<div className="flex gap-7">
    {urls.map((url,index) => (
    <SocialIcon key={index} url={url} large={large} />
  ))}
    </div>
  )
}

export default Socials
